import { Box } from "@mui/material";
import { MainScrollProvider } from "@/app/context/MainScrollContext";
import { ContentRouteFrame } from "./ContentRouteFrame";

type AppContentFrameProps = {
  mainElement: HTMLElement | null;
  onMainElementChange: (element: HTMLElement | null) => void;
};

/** The route outlet and its single scroll owner for both desktop and mobile. */
export const AppContentFrame = ({ mainElement, onMainElementChange }: AppContentFrameProps) => (
  <Box
    component="main"
    ref={onMainElementChange}
    data-main-scroll
    sx={{
      flex: 1,
      minHeight: 0,
      maxHeight: "100%",
      minWidth: 0,
      overflowY: "auto",
      overflowX: "clip",
      bgcolor: "background.default",
      boxSizing: "border-box",
      height: "100%",
      overscrollBehaviorY: "contain",
      scrollbarGutter: "stable",
      pt: { xs: "var(--mobile-app-bar-height, 44px)", md: 0 },
      pb: 0,
      scrollbarWidth: { xs: "none", md: "auto" },
      "&::-webkit-scrollbar": { display: { xs: "none", md: "block" } },
    }}
  >
    <MainScrollProvider element={mainElement}>
      <ContentRouteFrame />
    </MainScrollProvider>
  </Box>
);
